export default "__VITE_ASSET__adc92694__"